import Select from 'react-select';
import "./CustomSelect.scss";

// React-select applies minHeight:38px as an inline style, which overrides CSS classes.
// We use the styles prop to enforce the correct height at the JS level.
const HEIGHT = '46px';
const selectStyles = {
  control: (base) => ({ ...base, minHeight: HEIGHT, height: HEIGHT }),
  valueContainer: (base) => ({ ...base, padding: '0 14px', flexWrap: 'nowrap' }),
  indicatorsContainer: (base) => ({ ...base, height: HEIGHT }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (base) => ({ ...base, padding: '0 8px' }),
  input: (base) => ({ ...base, margin: '0', padding: '0' }),
  placeholder: (base) => ({ ...base, margin: '0' }),
  singleValue: (base) => ({ ...base, margin: '0' }),
};

export default function CustomSelect({
  options = [],
  value,
  onChange,
  placeholder = '-Select-',
  isSearchable = true,
  isDisabled = false,
  className,
  for: fieldFor,
  ...rest
}) {
  return (
    <div className="custom-select-container">
      <Select
        options={options}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        isSearchable={isSearchable}
        isDisabled={isDisabled}
        classNamePrefix="custom-select"
        className={className}
        styles={selectStyles}
        {...rest}
      />
    </div>
  );
}
